import { BLOCKS } from '@contentful/rich-text-types'
import React from 'react'
import PropTypes from 'prop-types'
import { getHeadingNameFromContent, slugifyHeading } from '../lib/heading'

const headingTypes = [BLOCKS.HEADING_2, BLOCKS.HEADING_3]

if (typeof window !== "undefined") {
  // eslint-disable-next-line global-require
  require("smooth-scroll")('a[href*="#"]')
}

const TableOfContents = ({ content, className }) => {
  const body = JSON.parse(content.raw)

  const headingBlocks = body.content.filter(item => headingTypes.includes(item.nodeType))
    .reduce((acc, { nodeType, ...node }) => {
      const name = getHeadingNameFromContent(node)
      if (nodeType === BLOCKS.HEADING_2) {
        return acc.concat({ nodeType, name })
      }

      if (acc[acc.length - 1]) {
        acc[acc.length - 1].items = (acc[acc.length - 1].items || []).concat({ nodeType, name })
      }

      return acc
    }, [])
  if (headingBlocks.length === 0) {
    return null
  }

  return (
    <nav className={className}>
      <h3>Sommaire</h3>
      <ul>
        {headingBlocks.map(({ name, items }) => (
          <li key={slugifyHeading(name)}>
            <a href={`#${slugifyHeading(name)}`}>{name}</a>
            {items && (
              <ul>
                {items.map(({ name: subNodeName }) => (
                  <li key={slugifyHeading(subNodeName)}>
                    <a className="text-sm" href={`#${slugifyHeading(subNodeName)}`}>{subNodeName}</a>
                  </li>
                ))}
              </ul>
            )}
          </li>
        )
        )}
      </ul>
    </nav>
  )
}

TableOfContents.propTypes = {
  content: PropTypes.object.isRequired,
  className: PropTypes.string,
}

export default TableOfContents
